import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons"
import { Button, Form, Input, Tabs } from "antd"
import { t } from "i18next"
import React from "react"

interface CustomLinksComponentProps {
  expandedCustomlink: boolean
  toggleCustomLinkExpand: () => void
  subTab: string
  handleSubTabChange: (key: string) => void
  form: any
  addToMenu: () => void
}

const CustomLinksItem: React.FC<CustomLinksComponentProps> = ({
  expandedCustomlink,
  toggleCustomLinkExpand,
  subTab,
  handleSubTabChange,
  form,
  addToMenu,
}) => {
  return (
    <div className={`border rounded-b-lg`}>
      <div
        className={`flex justify-between p-[10px] border-b border-gray-300 ${
          !expandedCustomlink ? "rounded-b-lg" : ""
        }`}
        onClick={toggleCustomLinkExpand}
      >
        <p className="text-base font-medium">{t("Custom Links")}</p>
        <p>{expandedCustomlink ? <CaretUpOutlined /> : <CaretDownOutlined />}</p>
      </div>

      <div
        className={`px-[10px] transition-all duration-300 ${
          expandedCustomlink ? "max-h-[400px] border-b border-gray-300 rounded-lg" : "max-h-0 overflow-hidden"
        }`}
      >
        <Tabs
          onChange={handleSubTabChange}
          type="card"
          activeKey={subTab}
          className="pt-4"
          items={[
            {
              label: t("Most Recent"),
              key: "tabMos",
            },
          ]}
        />
        {subTab === "tabMos" && (
          <div>
            <div>
              <Form layout="vertical" form={form}>
                <Form.Item label="URL" name="url">
                  <Input />
                </Form.Item>
                <Form.Item label={t("Link Text")} name="linktext">
                  <Input />
                </Form.Item>
              </Form>
            </div>
            <div className="flex justify-between py-[10px] items-center">
              <Button onClick={addToMenu}>{t("Add to menu")}</Button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default CustomLinksItem
